import type { RootState } from "../../../store"
import { useDispatch, useSelector } from "react-redux"
import { useGetCatalogoQuery, useGetLojaAtualQuery } from "@/api"
import { Stack } from "@mui/material"
import { atualizarKiosk, reprecificarItensKiosk } from "@/store/self-service-kiosk-slice"
import { useEffect } from "react"
import StartScreen from "./start-screen"
import SearchIdentifier from "./search-identifier"
import MultipleOrdersScreen from "./multiple-orders-screen"
import ItemsScreen from "./items-screen"
import AddItems from "./add-items-screen"
import PaymentScreen from "./payment-screen"
import ConfigTotemCheckout from "./config-totem-checkout"
import { SobreCardapio } from "@/components/sobre-cardapio"
import { TecladoTela } from "@/components/teclado-tela"
import { reconciliarCarrinhoTotem } from "@/lib/reconciliar-carrinho"

function CheckoutKiosk() {
  const dispatch = useDispatch()
  const currentView = useSelector((state: RootState) => state.selfServiceKiosk.currentView)
  const { data: loja } = useGetLojaAtualQuery()
  const { data: catalogo } = useGetCatalogoQuery('CARDAPIO_TOTEM_CHECKOUT', {
    pollingInterval: 60_000,
  })
  const cartItems = useSelector((state: RootState) => state.selfServiceKiosk.cartItems)

  useEffect(() => {
    const { correcoes, alteracoes } = reconciliarCarrinhoTotem(cartItems, catalogo)
    if (correcoes.length > 0) dispatch(reprecificarItensKiosk(correcoes))
      
    if (alteracoes.length > 0) dispatch(atualizarKiosk({ alteracoesPreco: alteracoes }))
  }, [catalogo, cartItems, dispatch])

  useEffect(() => {
    if (!loja) return

    dispatch(
      atualizarKiosk({
        logoUrl: loja.configuracao.urlLogo,
        modeloIdentificador: loja.configuracao.totemCheckoutIdentificador ?? 'COMANDA',
      }),
    )
  }, [loja, dispatch])

  return (
    <Stack direction={'column'} sx={{ alignItems: 'center', gap: 3, width: '100%' }}>
      {currentView === 'VIEW_START_SCREEN' && <StartScreen />}
      {currentView === 'VIEW_IDENTIFIER' && <SearchIdentifier />}
      {currentView === 'VIEW_MULTIPLE_ORDERS' && <MultipleOrdersScreen />}
      {currentView === 'VIEW_ITEMS' && <ItemsScreen />}
      {currentView === 'VIEW_ADD_ITEMS' && <AddItems />}
      {currentView === 'VIEW_PAYMENT' && <PaymentScreen />}
      {/* Na busca e no catálogo o "Sobre" tem lugar próprio na tela. */}
      {currentView !== 'VIEW_IDENTIFIER' && currentView !== 'VIEW_ADD_ITEMS' && <SobreCardapio />}

      <ConfigTotemCheckout />
      <TecladoTela />
    </Stack>
  )
}

export default CheckoutKiosk